/** @format */

import React, { useState, useEffect, Fragment } from "react";
import { ToastContainer, toast } from "react-toastify";
import "../App.css";

import { BrowserRouter as Router, Link, Route } from "react-router-dom";

export const AddStructures = () => {
  const [structure, setStructure] = useState({
    str_id: null,
    str_name: null,
    str_parent: null,
    str_head: null,
    // dep_description: null,
  });

  const [structures, setStructures] = useState([]);

  async function getStructures() {
    try {
      const getStr = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/structures`
      );
      const parsRes = await getStr.json();
      setStructures(parsRes);
    } catch (err) {
      console.error(err.message);
    }
  }

  const [positions, setPositions] = useState([]);
  async function getPositions() {
    try {
      const getPos = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/getPositions`
      );
      const parsRes = await getPos.json();
      setPositions(parsRes);
    } catch (err) {
      console.error(err.message);
    }
  }

  async function sendStructure() {
    try {
      const strSend = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/addStructure`,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
          },
          body: JSON.stringify(structure),
        }
      );

      if (strSend.ok) {
        getStructures();
      }
    } catch (err) {
      console.error(err.message);
    }
    document.getElementById("dep-add-btn").disabled = true;
  }

  async function editStructure() {
    try {
      const strEditSend = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/editStructure`,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
          },
          body: JSON.stringify(structure),
        }
      );
      if (strEditSend.ok) {
        getStructures();
        console.log("str_edit = OK");
      }
    } catch (err) {
      console.error(err.message);
    }
    document.getElementById("dep-add-btn").disabled = true;
  }

  const handleStrSubmit = (e) => {
    e.preventDefault();

    sendStructure();

    document.getElementById("dep-add-btn").disabled = true;
    document.getElementById("dep_name").value = "";
    document.getElementById("parent-select").value = 0;
    setStructure({ ...structure, str_name: "" });
  };

  const handleStrNameTxtChange = (e) => {
    document.getElementById("dep-add-btn").disabled = false;

    for (let i = 0; i < structures.length; i++) {
      if (structures[i].str_name == e.target.value) {
        document.getElementById("dep-add-btn").disabled = true;
      }
    }
    setStructure({ ...structure, str_name: e.target.value });
  };

  // ---------------

  //----------------

  useEffect(() => {
    document.getElementById("dep-add-btn").disabled = true;
    document.getElementById("dep-edit-btn").disabled = true;

    getPositions();
    getStructures();
  }, []);

  // useEffect(() => {
  //   if (structure == "") {
  //     document.getElementById("dep-add-btn").disabled = true;
  //   } else {
  //     document.getElementById("dep-add-btn").disabled = false;
  //   }
  // }, [structure]);
  // getStructures();

  const parentOptions = structures.map((str) => ({
    value: str.str_id,
    label: str.str_name,
  }));

  const handleStrEdit = () => {
    editStructure();

    document.getElementById("dep-edit-btn").disabled = true;
  };

  const [currentStrHead, setCurrentStrHead] = useState(0);
  const [selectedStructure, setSelectedStructure] = useState("");
  const [selectedStructure2, setSelectedStructure2] = useState("");
  const handleStrSelection = (sStr) => {
    document.getElementById("position-select").value = 0;
    document.getElementById("dep-edit-btn").disabled = true;

    for (let i = 0; i < structures.length; i++) {
      if (structures[i].str_id == sStr) {
        setSelectedStructure(structures[i].str_name);
        setSelectedStructure2(structures[i].str_name);

        if (structures[i].str_head == null) {
          setCurrentStrHead(0);
          document.getElementById("position-select").value = 0;
        } else {
          document.getElementById("position-select").value =
            structures[i].str_head;
          setCurrentStrHead(structures[i].str_head);

        }

        setStructure({ ...structure, str_id: sStr, str_head: structures[i].str_head });
      }
    }
  };

  const handlePosSelect = (e) => {
    setStructure({ ...structure, str_head: e.target.value });
    document.getElementById("dep-edit-btn").disabled = false;
  };

  const handleStrNameUpdateTxt = (e) => {
    setStructure({ ...structure, str_name: e.target.value });
    setSelectedStructure2(e.target.value);
    document.getElementById("dep-edit-btn").disabled = false;

  }


  return (
    <Fragment>
      <div className="pos-add-main-container ">
        <h5 className="pos-submit-title text-center">
          Ajouter et Modifier une structure
        </h5>
        <div className="str-container">
          <div className="str-mod">
            <div className="str-add-container">
              <label htmlFor="pos-add-display">Ajouter</label>

              <div className="pos-add-display form-control">
                <form
                  onSubmit={handleStrSubmit}
                  className="str-pos-submit-form "
                >
                  <div id="input-container-add" className="input-container ">
                    <div className="input-fields">
                      <div className="str-input-each">
                        <label className="str-select-label" htmlFor="dep_name">
                          Titre de la structure
                        </label>
                        <input
                          className="form-control"
                          id="dep_name"
                          type="text"
                          value={structure.dep_name}
                          onChange={handleStrNameTxtChange}
                        ></input>
                      </div>
                      <div className="str-input-each">
                        <label className="str-select-label">
                          Structure Parent:
                        </label>

                        <select
                          className="form-control"
                          id="parent-select"
                          onChange={(e) =>
                            setStructure({
                              ...structure,
                              str_parent: e.target.value,
                            })
                          }
                        >
                          <option value={0} disabled selected>
                            --Selectioner la strecture parent--
                          </option>
                          {parentOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <button
                      id="dep-add-btn"
                      className="form-control btn btn-primary dep-add-btn"
                    >
                      Ajouter
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div className="str-edit-container">
              <label htmlFor="pos-edit-display">Modifier</label>
              <div
                id="pos-edit-display"
                className="input-container form-control"
              >

                <div className="input-fields">
                  <div className="str-mod-info">
                    <span>Modifier la structure: {selectedStructure}</span>
                  </div>

                  <form className="pos-edit-form ">
                    <label for="title-change">Modifier le titre de la Structure:</label>

                    <div className="title-change">
                      <input
                        className="form-control"
                        id="dep_name"
                        type="text"
                        value={selectedStructure2}
                        onChange={handleStrNameUpdateTxt}
                      ></input>
                    </div>
                  </form>
                </div>
                <div className="input-fields">


                  <form className="pos-edit-form ">
                    <label for="pos-select">Responsable de la Structure:</label>

                    <div className="pos-select">
                      <label
                        className="position-select-label "
                        for="position-select"
                      >
                        Position:
                      </label>
                      <select
                        id="position-select"
                        className="position-select form-control"
                        onChange={handlePosSelect}
                      >
                        <option id="default-option" value={0} disabled selected>
                          {" "}
                          --Selectioner--{" "}
                        </option>
                        {positions.map((position) => (
                          <option
                            key={position.role_id}
                            value={position.role_id}
                          >
                            {position.role_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </form>
                </div>

                <button
                  id="dep-edit-btn"
                  className="form-control btn btn-primary dep-add-btn"
                  onClick={handleStrEdit}
                >
                  Mettre à jour
                </button>
              </div>
            </div>
          </div>

          <div className="pos-current-list">
            <table className="pos-list-table table">
              <thead>
                <tr>
                  <th>N°</th>
                  <th>structure</th>
                </tr>
              </thead>
              <tbody>
                {structures.map((structure, index) => (
                  <tr
                    onClick={(e) => handleStrSelection(structure.str_id)}
                    className="table-row"
                    key={structure.str_id}
                  >
                    <td>{index + 1}</td>
                    <td>{structure.str_name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
